// src/plugins/echo.ts
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

declare global {
  interface Window {
    Pusher: typeof Pusher;
  }
}

window.Pusher = Pusher;

const PUSHER_KEY = process.env.VUE_APP_PUSHER_APP_KEY || '';
const PUSHER_CLUSTER = process.env.VUE_APP_PUSHER_APP_CLUSTER || 'eu';
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '';
const BACKEND_BASE_URL = process.env.VUE_APP_BACKEND_BASE_URL
  || API_BASE_URL.replace(/\/api\/?$/, ''); // fallback: /api'yi siler

const token = localStorage.getItem('auth_token');

const echo = new Echo({
  broadcaster: 'pusher',
  key: PUSHER_KEY,
  cluster: PUSHER_CLUSTER,
  forceTLS: false, // localhost için
  authEndpoint: `${BACKEND_BASE_URL}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      Accept: 'application/json',
    },
  },
});

export default echo;
